export const LIST_EVENT = 'LIST_EVENT';
export const LIST_EVENT_SUCCESS = 'LIST_EVENT_SUCCESS';
export const LIST_EVENT_ERROR = 'LIST_EVENT_ERROR';